<template>
  <el-container>
    <!-- <el-header style="padding:0;"> -->
    <Head ref="head" v-show="isShowHead"/>
    <!-- </el-header> -->
    <router-view></router-view>
    <!-- <el-footer>   -->
    <Foot v-show="isShowHead"/>
    <!-- </el-footer> -->
  </el-container>
</template>

<script>
import Head from "@/components/Header";
import Foot from "@/components/Footer";
export default {
  data(){
    return{
      isShowHead:false
    }
  },
  components: {
    Head,
    Foot
  },
  updated(){
    if(this.$route.path.indexOf('school') > -1){
      this.isShowHead = false
    }else{
      this.isShowHead = true
    }
    this.$refs['head'].initView()
  },
};
</script>
